import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import Store from "@/stores";

@observer
class Paging extends Component {
	render() {
		return <ul className="ladder-paging">{this.formatPage()}</ul>;
	}
	select(index) {
		const { getRanking } = Store._ladderStore;
		getRanking(index);
		const target = document.getElementsByClassName("ladder-ranking")[0];
		const scrollToTop = setInterval(() => {
			const pos = window.pageYOffset;
			pos > target.offsetTop ? scrollTo(0, pos - 20) : clearInterval(scrollToTop);
		}, 5);
	}
	formatPage() {
		const { rankingIndex, rankingMaxIndex } = Store._ladderStore;
		let page = [...Array(rankingMaxIndex + 1).keys()];
		if (rankingMaxIndex > 6) {
			if (rankingIndex < 3) {
				page = page.slice(0, 7);
			} else if (rankingIndex > rankingMaxIndex - 3) {
				page = page.slice(rankingMaxIndex - 6);
			} else {
				page = page.slice(rankingIndex - 3, rankingIndex + 4);
			}
		}
		const result = page.map(v => <li key={v} className={rankingIndex === v ? "active" : ""} onClick={this.select.bind(this, v)}>{v + 1}</li>);
		if (rankingMaxIndex > 6) {
			result.unshift(<li key="first" className="first-page" onClick={this.select.bind(this, 0)}>首页</li>);
			result.push(<li key="last" className="last-page" onClick={this.select.bind(this, rankingMaxIndex)}>尾页</li>);
		}
		return result;
	}
}
export default Paging;